import { Attributes, Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class InvestorAccrualScheduleReportCriteria extends Model.CriteriaBase {

    @Rules.Required()
    @Attributes.Nullable()
    public investorInvestmentId: number | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public investorInvestmentName: string = "";

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Investor Client Schedule Report Criteria";
    }
}